export default "__VITE_ASSET__22e8f735__"